export default __webpack_public_path__ + "static/media/active.23d0e18a.svg";